/**
 * CustomerListHeader Component
 * Search bar and action buttons for customer list
 */

import React from 'react';
import { Paper, Stack, TextField, Button, InputAdornment } from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import { STYLES } from '../constants/customerTableConfig';

interface CustomerListHeaderProps {
  search: string;
  onSearchChange: (search: string) => void;
  onAddCustomer: () => void;
}

export const CustomerListHeader: React.FC<CustomerListHeaderProps> = ({
  search,
  onSearchChange,
  onAddCustomer,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        p: 2,
        border: '1px solid',
        borderColor: '#e5e7eb',
        borderRadius: 1.5,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <TextField
          placeholder="Search by name, email, phone, address, or notes..."
          size="small"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 20, color: '#9ca3af' }} />
              </InputAdornment>
            ),
          }}
          sx={STYLES.searchField}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: 18 }} />}
          onClick={onAddCustomer}
          sx={STYLES.newCustomerButton}
        >
          New Customer
        </Button>
      </Stack>
    </Paper>
  );
};

export default CustomerListHeader;
